import axios from "axios";
import {isExpired, decodeToken} from "react-jwt";

const api = axios.create({
    baseURL: 'https://fleet.networkite.com'
});

// ..... adding headers ....
api.interceptors.request.use(
    (config) => {
        const token = sessionStorage.getItem('token');
        const smlToken = sessionStorage.getItem('smlToken');
        if (token) config.headers.Authorization = token;
        if (smlToken) config.headers.Smltoken = smlToken;
        return config;
    },
    (error) => Promise.reject(error)
)

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        console.log('refreshed token');
        const originalRequest = error.config;

        const token = sessionStorage.getItem('token');
        const decodedToken = decodeToken(token);
        const isTokenExpired = isExpired(token);

        if (isTokenExpired && error.response.status === 401) {
            originalRequest._retry = true;
            try {
                const refreshToken = sessionStorage.getItem('refreshToken');
                const response = await api.get('/auth/refresh-token',
                    {
                        headers: {
                            uname: decodedToken.username,
                            rtoken: refreshToken
                        }
                    })

                const tokens = response.data;

                if (tokens?.token) sessionStorage.setItem('token', tokens.token);
                if (tokens?.idToken) sessionStorage.setItem('idToken', tokens.idToken);
                if (tokens?.refreshToken) sessionStorage.setItem('refreshToken', tokens.refreshToken);

                // Retry the original request with the new token
                originalRequest.headers.Authorization = tokens.token;
                originalRequest.headers.Smltoken = tokens.smlToken;

            } catch (e) {
                console.log(e);
            }
        }

        return Promise.reject(error);
    }
)


export default api;
